import { render, staticRenderFns } from "./WebappEditLinkedData.vue?vue&type=template&id=3ffb42df&"
import script from "./WebappEditLinkedData.vue?vue&type=script&lang=js&"
export * from "./WebappEditLinkedData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports